import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  searchWithoutQuery: true,
};

export const resourceDetailSlice = createSlice({
  name: 'resourceDetailSlice',
  initialState,
  reducers: {
    setSearchWithoutQuery: (state, action) => {
      state.searchWithoutQuery = action.payload;
    },
  },
});

export const { setSearchWithoutQuery } = resourceDetailSlice.actions;
